import React, { Component } from 'react'
import TermSheetScheduleRowsUI from './TermSheetScheduleRowsUI.js'

class TermSheetScheduleRowsSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedRow: null,
      createMode: false,
      updateMode: false,
      deleteMode: false,
      refreshFromMasterMode: false,
    }
  }

  render() {
    return (
      <TermSheetScheduleRowsUI
        context={this.props.context}
        loan={this.props.loan}    
        title={this.props.title}
        scheduleRowList={this.props.scheduleRowList}
        createMode={this.state.createMode}
        onCreateRowClick={() => { this.setState({ createMode: true }) }}
        onCreateRowCancel={() => { this.setState({ createMode: false }) }}
        updateMode={this.state.updateMode}
        selectedRow={this.state.selectedRow}
        onUpdateRowClick={this.onUpdateRowClick}
        onUpdateRowCancel={() => { this.setState({ updateMode: false, selectedRow: null }) }}
        deleteMode={this.state.deleteMode}
        onDeleteRowClick={this.onDeleteRowClick}
        onDeleteRowCancel={() => { this.setState({ deleteMode: false, selectedRow: null }) }}
        refreshFromMasterMode={this.state.refreshFromMasterMode}
        onRefreshFromMasterClick={() => { this.setState({ refreshFromMasterMode: true }) }}
        onRefreshFromMasterCancel={() => { this.setState({ refreshFromMasterMode: false }) }}
        onRefreshClick={this.props.onRefreshClick}
      />
    )
  }

  onUpdateRowClick = (event) => {
    const templateId = event.currentTarget.getAttribute('template-id')
    const row = this.props.scheduleRowList.filter(r => r.templateId === templateId)[0]
    this.setState({ selectedRow: row, updateMode: true })
  }

  onDeleteRowClick = (event) => {
    const templateId = event.currentTarget.getAttribute('template-id')
    const row = this.props.scheduleRowList.filter(r => r.templateId === templateId)[0]
    this.setState({ selectedRow: row, deleteMode: true })
  }
}

export default TermSheetScheduleRowsSF
